import { AlpineComponent } from 'alpinejs';

type ImportFormData = {
  changeAction: (type: string) => void;
}

export default ():AlpineComponent<ImportFormData> => ({
  changeAction(type) {
    const form = document.querySelector('form#import-form') as HTMLFormElement;
    if (form) {
      const actionInput = document.querySelector('input#formAction') as HTMLInputElement;
      if (actionInput) {
        actionInput.value = type;
        form.submit();
      }
    }
  }
});
